import { clientsConstants } from "../constants/action.constants";

const initialState = {
  submitting: false,
  submitted: false,
  request: null,
  response: null,
  error: null
};

export const addClient = (state = initialState, action) => {
  switch (action.type) {
    case clientsConstants.ADD_CLIENT_REQUEST:
      return {
        ...state,
        submitting: true,
        submitted: false,
        request: action.requestBody,
        response: null,
        error: null
      };
    case clientsConstants.ADD_CLIENT_SUCCESS:
      return {
        ...state,
        submitting: false,
        submitted: true,
        response: action.response,
        error: null
      };
    case clientsConstants.ADD_CLIENT_FAILURE:
      return {
        ...state,
        submitting: false,
        submitted: false,
        response: null,
        error: action.error
      };
    case clientsConstants.ADD_CLIENT_RESET:
      return {
        ...state,
        ...initialState
      };
    default:
      return state;
  }
};
